import { fetchFactory } from 'isotope-client'
import { DetailFertilisation } from './fertilisation.types'

export const getFertilisationsByPlanche = (plancheId: string): Promise<DetailFertilisation[]> => fetchFactory(`/planche/${plancheId}/fertilisations`)
